import React, { useState} from "react";
import { Accordion, Card } from "react-bootstrap";

export default function HaldiService({haldiService}) {
    const [activeKey, setActiveKey] = useState("0");
    const handleToggle = (key) => {
        setActiveKey(activeKey === key ? null : key);
    };

  return (
    <>
    <section className="haldipage-service">
        <div className="container">
            <div className="row align-items-center">

                <div className="col-lg-12">
                    <div className="haldiservice-head">
                        <span className="gradient-color">{haldiService?.tagline}</span>
                        <h2 className='heading'>{haldiService?.heading}</h2>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6 order-2 order-md-1 order-lg-1">
                    <img src={haldiService?.image} className="img-responsive" alt="service" loading="lazy"/>
                </div>

                <div className="col-lg-6 col-md-6 order-1 order-md-2 order-lg-2">
                    <Accordion activeKey={activeKey} className="service-accord">
                        {haldiService?.accordions?.map((item, index) => (
                            <Card key={index} className={activeKey === String(index) ? "active" : ""}>
                                <Card.Header>
                                    <Accordion.Item eventKey={String(index)}>
                                    <Accordion.Header as="span" onClick={() => handleToggle(String(index))}>
                                        {item.title}
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>{item.description}</p>
                                    </Accordion.Body>
                                    </Accordion.Item>
                                </Card.Header>
                            </Card>
                        ))}
                    </Accordion>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}


